import Link from "@material-ui/core/Link"
import Typography from "@material-ui/core/Typography"
import React from "react"

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"© "}
            {new Date().getFullYear()}
            <Link color="inherit" href="https://guokr.com/" target="_blank">
                &nbsp;guokr
            </Link>{" "}
        </Typography>
    )
}

export default Copyright
